export default {
  4013: '设备存在风险',
  4011: '您的账号存在异常无法领取奖励',
  4003: '登陆态过期，请重新登陆',
};
